/* ============================================================
   Neural Expressive — ぬるぬる JS (2026-06-01)
   軽量(~2KB) / 依存なし / defer / scrollイベント不使用。
   1) Magnetic CTA: pointermove で軽い吸着(transformのみ・上限あり)
   2) Reveal フォールバック: CSS view() 非対応時のみ IntersectionObserver
   reduced-motion / coarse pointer では no-op。
   ============================================================ */
(function () {
  "use strict";

  var reduce = false;
  try {
    reduce = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {}

  /* ---------- 1) Magnetic CTA ---------- */
  function initMagnetic() {
    if (reduce) return;
    // タッチ主体端末では吸着を無効(誤作動・パフォ配慮)
    var fine = window.matchMedia &&
      window.matchMedia("(pointer: fine)").matches;
    if (!fine) return;

    var MAX = 6; // px 上限(やり過ぎない)
    var nodes = document.querySelectorAll("[data-ne-magnetic]");
    Array.prototype.forEach.call(nodes, function (el) {
      el.addEventListener("pointermove", function (ev) {
        var r = el.getBoundingClientRect();
        var dx = ((ev.clientX - (r.left + r.width / 2)) / (r.width / 2)) * MAX;
        var dy = ((ev.clientY - (r.top + r.height / 2)) / (r.height / 2)) * MAX;
        el.style.transform = "translate3d(" + dx.toFixed(1) + "px," + dy.toFixed(1) + "px,0)";
      });
      el.addEventListener("pointerleave", function () {
        el.style.transform = "";
      });
    });
  }

  /* ---------- 2) Reveal フォールバック ---------- */
  function initReveal() {
    if (reduce) return;
    var nativeOK = false;
    try { nativeOK = CSS.supports("animation-timeline", "view()"); } catch (e) {}
    if (nativeOK) return; // ネイティブCSSが処理 → JS不要

    var els = document.querySelectorAll("[data-ne-reveal]");
    if (!els.length) return;

    if (!("IntersectionObserver" in window)) {
      // 最終手段: 即表示(崩れ・チラつき回避を最優先)
      Array.prototype.forEach.call(els, function (el) { el.classList.add("ne-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("ne-in");
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function boot() {
    try { initMagnetic(); } catch (e) {}
    try { initReveal(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
